import { useContext } from 'react';

import { DragAndDropContext } from 'contexts/drag-and-drop/DragAndDropContext';

export const useDragAndDrop = () => {
  const dragAndDropState = useContext(DragAndDropContext);
  return dragAndDropState;
};
